export default __webpack_public_path__ + "static/edit-5cf17aa94a641ac090d12a8d70642300.svg";